import { DEPLOY_PACKAGE_ICONS } from '../../deploy-package-icons'
import type { LinuxDistroTabEntry } from './deploy-package-download.types'

const LINUX_TONGXIN_PREFIX = '统信系统'
const LINUX_QILIN_PREFIX = '麒麟系统'
const LINUX_CENTOS_PREFIX = 'CentOS'
const LINUX_UBUNTU_PREFIX = 'Ubuntu'
const LINUX_ARCH_ORDER = ['amd64', 'arm64', 'mips64el', 'mips64', 'loongarch64']

/** 大小写不敏感的 startsWith */
function startsWithIgnoreCase (str: string, prefix: string): boolean {
  return str.length >= prefix.length &&
    str.slice(0, prefix.length).toLowerCase() === prefix.toLowerCase()
}

export function linuxMapKeyDisplayBase (mapKey: string): string {
  const trimmed = mapKey.trim()
  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length < 2) {
    return trimmed
  }
  const last = parts[parts.length - 1].toLowerCase()
  const archSet = new Set(LINUX_ARCH_ORDER.map(a => a.toLowerCase()))
  if (archSet.has(last)) {
    return parts.slice(0, -1).join(' ')
  }
  return trimmed
}

export function cornerIconForLinuxSystem(system: string): string {
  if (system.startsWith(LINUX_TONGXIN_PREFIX)) return DEPLOY_PACKAGE_ICONS.linuxTongxin
  if (system.startsWith(LINUX_QILIN_PREFIX)) return DEPLOY_PACKAGE_ICONS.linuxQilin
  return DEPLOY_PACKAGE_ICONS.linux
}

function linuxMapKeyArchSuffix (mapKey: string): string {
  const parts = mapKey.trim().split(/\s+/)
  return parts[parts.length - 1] || mapKey
}

function sortLinuxGroupMapKeys (mapKeys: string[]): string[] {
  return [...mapKeys].sort((a, b) => {
    const archA = linuxMapKeyArchSuffix(a)
    const archB = linuxMapKeyArchSuffix(b)
    const ia = LINUX_ARCH_ORDER.indexOf(archA)
    const ib = LINUX_ARCH_ORDER.indexOf(archB)
    if (ia !== -1 && ib !== -1) return ia - ib
    if (ia !== -1) return -1
    if (ib !== -1) return 1
    return a.localeCompare(b, 'zh-CN')
  })
}

export function buildLinuxDistroTabEntries (systems: string[]): LinuxDistroTabEntry[] {
  const tongxin = systems.filter(s => s.startsWith(LINUX_TONGXIN_PREFIX))
  const qilin = systems.filter(s => s.startsWith(LINUX_QILIN_PREFIX))
  const centos = systems.filter(s => startsWithIgnoreCase(s, LINUX_CENTOS_PREFIX))
  const ubuntu = systems.filter(s => startsWithIgnoreCase(s, LINUX_UBUNTU_PREFIX))
  const rest = systems.filter(
    s => !s.startsWith(LINUX_TONGXIN_PREFIX) &&
      !s.startsWith(LINUX_QILIN_PREFIX) &&
      !startsWithIgnoreCase(s, LINUX_CENTOS_PREFIX) &&
      !startsWithIgnoreCase(s, LINUX_UBUNTU_PREFIX)
  )
  const entries: LinuxDistroTabEntry[] = rest.map(k => ({
    tabId: k,
    label: linuxMapKeyDisplayBase(k),
    mapKeys: [k],
  }))
  if (centos.length) {
    entries.push({
      tabId: '__linux_centos__',
      label: LINUX_CENTOS_PREFIX,
      mapKeys: sortLinuxGroupMapKeys(centos),
    })
  }
  if (ubuntu.length) {
    entries.push({
      tabId: '__linux_ubuntu__',
      label: LINUX_UBUNTU_PREFIX,
      mapKeys: sortLinuxGroupMapKeys(ubuntu),
    })
  }
  if (tongxin.length) {
    entries.push({
      tabId: '__linux_tongxin__',
      label: LINUX_TONGXIN_PREFIX,
      mapKeys: sortLinuxGroupMapKeys(tongxin),
    })
  }
  if (qilin.length) {
    entries.push({
      tabId: '__linux_qilin__',
      label: LINUX_QILIN_PREFIX,
      mapKeys: sortLinuxGroupMapKeys(qilin),
    })
  }
  return entries
}
